import { featureList } from "@/mocks/trending";

export default function FeatureBoard() {
  return (
    <section id="features" className="w-full bg-background-50 px-4 py-12 md:px-8 md:py-16 lg:px-14">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-file-list-3-fill" aria-hidden="true"></i> 每周原创长文
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              深度盘点 <span className="text-primary-500">不止吃瓜，更懂门道</span>
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-500">
              不只告诉你在刷什么，更拆解为什么它会疯传。传播链、情绪点、出圈公式，一次讲透。
            </p>
          </div>
          <a href="#subscribe" className="shrink-0 whitespace-nowrap rounded-full border border-background-200 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700">
            订阅不错过更新
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {featureList.map((f) => (
            <article
              key={f.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden">
                <img
                  src={f.image}
                  alt={f.imageAlt}
                  title={`${f.title} · 吃瓜爆网深度盘点`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-4 top-4 flex gap-2">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">{f.category}</span>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span>{f.date}</span>
                  <span>·</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true"></i> 约 {f.readMinutes} 分钟
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-xl">
                  {f.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{f.excerpt}</p>
                <a href="#subscribe" className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800">
                  阅读全文 <i className="ri-arrow-right-circle-line text-base" aria-hidden="true"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}